import { render, staticRenderFns } from "./form-file-image.vue?vue&type=template&id=18ba470d"
import script from "./form-file-image.vue?vue&type=script&lang=js"
export * from "./form-file-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports